export default __webpack_public_path__ + "static/f30-371ce0986c19b73fc37f2ba970ad39ba.svg";